import React from 'react';
import { Text } from 'Common/components/Atoms/Text';

interface Props {
  children: string;
}

export function Subtitle({ children }: Props): JSX.Element {
  return (
    <Text textAlign="center" variant="body1" mb={4}>
      {children}
    </Text>
  );
}
